'use strict';
import * as $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6 from "./internal-3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.js";
import * as $j_presto$002etypes$0024$002dRole$002dName$0024$0024anon$002487 from "./presto.types$-Role-Name$$anon$87.js";
var $p;
/** @constructor */
function $c_Lpresto_types$RoleName$() {
  this.ca1 = null;
  this.ca2 = false;
  this.ca5 = null;
  this.ca6 = false;
  this.ca3 = null;
  this.ca4 = false;
}
export { $c_Lpresto_types$RoleName$ as $c_Lpresto_types$RoleName$ };
$p = $c_Lpresto_types$RoleName$.prototype = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$h_O();
$p.constructor = $c_Lpresto_types$RoleName$;
/** @constructor */
function $h_Lpresto_types$RoleName$() {
}
export { $h_Lpresto_types$RoleName$ as $h_Lpresto_types$RoleName$ };
$h_Lpresto_types$RoleName$.prototype = $p;
$p.nQ = (function() {
  if ((!this.ca2)) {
    this.ca1 = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lio_circe_Decoder$().a9;
    this.ca2 = true;
  }
  return this.ca1;
});
$p.cJP = (function() {
  if ((!this.ca6)) {
    this.ca5 = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_Lcom_raquo_laminar_modifiers_RenderableText$$anon$1(new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sjsr_AnonFunction1(((x) => x)), $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lcom_raquo_laminar_modifiers_RenderableText$());
    this.ca6 = true;
  }
  return this.ca5;
});
$p.ct3 = (function() {
  if ((!this.ca4)) {
    this.ca3 = new $j_presto$002etypes$0024$002dRole$002dName$0024$0024anon$002487.$c_Lpresto_types$RoleName$$anon$87(this);
    this.ca4 = true;
  }
  return this.ca3;
});
var $d_Lpresto_types$RoleName$ = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$TypeData().i($c_Lpresto_types$RoleName$, "presto.types$RoleName$", ({
  a1d: 1,
  D: 1
}));
export { $d_Lpresto_types$RoleName$ as $d_Lpresto_types$RoleName$ };
var $n_Lpresto_types$RoleName$;
function $m_Lpresto_types$RoleName$() {
  if ((!$n_Lpresto_types$RoleName$)) {
    $n_Lpresto_types$RoleName$ = new $c_Lpresto_types$RoleName$();
  }
  return $n_Lpresto_types$RoleName$;
}
export { $m_Lpresto_types$RoleName$ as $m_Lpresto_types$RoleName$ };
//# sourceMappingURL=presto.types$-Role-Name$.js.map
